import { AbstractPmsApiService } from './abstract.service'
import { User } from "../models";

/**
 * @class MabeetUserPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<User>}
 */
export class MabeetUserPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/mabeet-user(/:id)'
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {User}
     * @protected
     */
    newModel(attributes, ...params) {

        return new User(attributes);
    }

    /**
     * @param {Object=} params
     * @returns {Promise.<PaginationCollection<User>>}
     */
    get(params = {}) {

        const url = this.url();

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params,
            })
            .then(this.getPaginationCollector())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {User} user
     * @returns {Promise.<User>}
     */
    create(user) {

        const url = this.url();

        return this.http
            .post(url, user.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Integer} userId
     * @param {Object} params
     */
    show(userId, params = {}) {

        const url = this.url({
            id: userId
        });

        return this.http
            .get(url, {
                headers: this.authHeaders,
                params
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {User} user
     * @returns {Promise.<User>}
     */
    update(user) {

        const url = this.url({
            id: user.id
        });

        return this.http
            .put(url, user.toObject(), {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {User} user
     * @returns {Promise.<boolean>}
     */
    delete(user) {

        const url = this.url({
            id: user.id
        });

        return this.http
            .delete(url, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {User} user
     * @returns {Promise.<boolean>}
     */
    resendActivationEmail(user) {

        const url = `${this.url({id: user.id})}/resend-email`;

        return this.http
            .post(url, {}, {
                headers: this.authHeaders
            })
            .then(this.getStatusExtractor())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/mabeet-user.service.js